import React, { useState, useEffect, useContext } from 'react';
import { IconButton, TextField, Modal, Typography, Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import './organizationStaff.css'
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import UserContext from '../../Context/User/userContext.jsx';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#169a8f',
        color: theme.palette.common.white,
        textAlign: 'center',
        fontWeight:800,
        fontSize: 16,
        fontFamily:'nunito'

    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 18,
         color: '#178383',
        textAlign: 'center',
        fontWeight:600,
        fontFamily:'nunito'
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));



const OrganizationStaff = ({ setShowSpinner }) => {
    const [allStaffs, setAllStaffs] = useState([])
    const [adminExist, setAdminExist] = useState(false)

    // Bearer Token
    const token = localStorage.getItem('token');
    const tokenValue = token ? token.slice(1, token.length - 1) : ""

    // User Object
    const { user, setUser } = useContext(UserContext);
    const id = user && (typeof user === 'string' ? JSON.parse(user)._id : user._id);
    const getData = () => {
        setShowSpinner(true);
        const url = `https://research-mate-b35a10757d5a.herokuapp.com/api/staff?addedById=${id}`;
        axios.get(url, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${tokenValue}`
            }
        })
            .then(res => {
                setShowSpinner(false);
                setAllStaffs(res.data.data)
            })
            .catch(error => {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: error.response?.data?.message,
                });
            })
    }
    const checkForAdmin = async () => {
        try {
            const response = await axios.get(`https://research-mate-b35a10757d5a.herokuapp.com/api/auth/validateAdmin/${id}`, {
                headers: {
                    'Authorization': `Bearer ${tokenValue}`
                    // You can add other headers if needed like authorization token, etc.
                }
            });

            // Determine if the user is an admin based on the API response
            setAdminExist(response.data.success);
        } catch (error) {
            console.error("Error:", error.response?.data?.message || error.message);
            setAdminExist(false); // Return false in case of an error
        }
    };
    useEffect(() => {
        if (user) {
            getData()
            checkForAdmin()
        }
    }, [user])

    const [open, setOpen] = useState(false);
    const [designation, setDesignation] = useState('');

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        reset()
    };

    const [cvFile, setCvFile] = useState(null);
    const [mlFile, setMlFile] = useState(null);
    const [gcFile, setGcFile] = useState(null);
    const [name, setName] = useState(null);
    const [speciality, setSpeciality] = useState(null);
    const [email, setEmail] = useState(null);
    const [phone, setPhone] = useState(null);
    const [showFileUpload, setShowFileUpload] = useState('PI');

    const reset = () => {
        setGcFile(null)
        setMlFile(null)
        setGcFile(null)
        setName(null)
        setEmail(null)
        setPhone(null)
        setSpeciality(null)
    }

    const handleSubmit = async (_id) => {
        setShowSpinner(true);
        // Assuming 'cvFile', 'mlFile', 'gcFile' are the file objects obtained from the input elements
        const formData = new FormData();
        formData.append('cv', cvFile);
        formData.append('ml', mlFile);
        formData.append('gc', gcFile);

        // URL for uploading documents https://research-mate-b35a10757d5a.herokuapp.com/
        const uploadUrl = `https://research-mate-b35a10757d5a.herokuapp.com/api/staff/uploadDocument?name=${_id}`;

        // Make the API request to upload documents
        axios.post(uploadUrl, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${tokenValue}`
            }
        })
            .then(res => {
                Swal.fire({
                    title: "Added!",
                    text: "Your staff has been added",
                    icon: "success",
                    customClass: {
                        container: 'swal2-container-custom'
                    }
                });
                // Reset all fileds
                reset();
                //Close Modal
                handleClose();
                // Get data Again
                getData()
            })
            .catch(error => {
                // Handle error
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: error.response?.data?.message || error.message,
                    customClass: {
                        container: 'swal2-container-custom'
                    }
                });
            })
            .finally(() => {
                setShowSpinner(false);
            })
    };

    const handleDataSubmit = () => {
        setShowSpinner(true);
        // Staff information
        const staff = {
            name,
            email,
            phone,
            speciality,
            designation,
            documents: [],
            addedBy: id,
            studies: []
        };
        // URL for saving staff information
        const saveUrl = 'https://research-mate-b35a10757d5a.herokuapp.com/api/staff';
        if (designation === 'Site Manager' || designation === 'Sub-Eye' || designation === 'Study Manager') {
            // Make the API request to save staff information
            axios.post(saveUrl, staff, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${tokenValue}`
                }
            })
                .then(saveResponse => {
                    // Reset all fileds
                    reset();
                    //Close Modal
                    handleClose();
                    // Get data Again
                    getData()
                })
                .catch(error => {
                    // Handle error
                    Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: error.response?.data?.message || error.message,
                        customClass: {
                            container: 'swal2-container-custom'
                        }
                    });
                })
                .finally(() => {
                    setShowSpinner(false);
                })
        }
        else {
            if (cvFile && gcFile && mlFile) {
                if (cvFile.type === 'application/pdf' && gcFile.type === 'application/pdf' && mlFile.type === 'application/pdf') {
                    // Make the API request to save staff information
                    axios.post(saveUrl, staff, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${tokenValue}`
                        }
                    })
                        .then(saveResponse => {
                            handleSubmit(saveResponse.data.data._id)
                        })
                        .catch(error => {
                            // Handle error
                            Swal.fire({
                                icon: "error",
                                title: "Oops...",
                                text: error.response?.data?.message || error.message,
                                customClass: {
                                    container: 'swal2-container-custom'
                                }
                            });
                        })
                        .finally(() => {
                            setShowSpinner(false);
                        })
                } else {
                    // Handle error
                    Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: 'File type should be a pdf',
                        customClass: {
                            container: 'swal2-container-custom'
                        }
                    });
                    setShowSpinner(false);
                }
            } else {
                // Handle error
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: `For "${designation}" all document are required`,
                    customClass: {
                        container: 'swal2-container-custom'
                    }
                });
                setShowSpinner(false);
            }
        }
    }


    return (
        <Box sx={{ p: 2, color: '#169a8f', fontWeight: 'bold' }}>
            <IconButton variant="outlined" onClick={handleOpen} sx={{ bgcolor: '#169a8f', '& .MuiSvgIcon-root': { fontSize: '2.5rem' } }}>
                <AddIcon />
            </IconButton>

            <Modal open={open} onClose={handleClose}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '90%',
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 4,
                    }}
                >
                   <h4 style={{color: '#169a8f'}}>Add Staff</h4>
                    <div className='row col-md-12 d-flex justify-content-center align-items-center'>
                        <div className='col-md-3'>
                            <TextField
                                InputLabelProps={{ style: { fontSize: 18, color: '#169a8f'} }}
                                InputProps={{ style: { fontSize: 18 } }}
                                id="outlined-basic"
                                label="Name"
                                variant="outlined"
                                style={{ width: '100%' }} 
                                onChange={e => setName(e.target.value)}
                            />
                        </div>
                        <div className='col-md-3'>
                            <TextField
                                InputLabelProps={{ style: { fontSize: 18, color: '#169a8f' } }}
                                InputProps={{ style: { fontSize: 18 } }}
                                id="outlined-basic"
                                label="Speciality"
                                variant="outlined"
                                style={{ width: '100%' }} 
                                onChange={e => setSpeciality(e.target.value)}
                            />
                        </div>
                        <div className='col-md-3'>
                            <TextField
                                InputLabelProps={{ style: { fontSize: 18, color: '#169a8f' } }}
                                InputProps={{ style: { fontSize: 18 } }}
                                id="outlined-basic"
                                label="Email"
                                variant="outlined"
                                style={{ width: '100%' }} 
                                onChange={e => setEmail(e.target.value)}
                            />
                        </div>
                        <div className='col-md-3'>
                            <TextField
                                InputLabelProps={{ style: { fontSize: 18, color: '#169a8f' } }}
                                InputProps={{ style: { fontSize: 18 } }}
                                id="outlined-basic"
                                label="Phone"
                                variant="outlined"
                                style={{ width: '100%' }} 
                                onChange={e => setPhone(e.target.value)}
                            />
                        </div>
                        <div className='col-md-3 mt-4'>
                            <FormControl fullWidth >
                                <InputLabel 
                                 id="demo-simple-select-label"
                                 style={{
                                   fontSize: 18, 
                                   color: '#169a8f',
                                 }}
                                >Designation</InputLabel>
                                <Select
                                    value={designation}
                                    label="Designation"
                                    onChange={e => {
                                        setShowFileUpload(e.target.value)
                                        setDesignation(e.target.value)
                                    }}
                               
                                >
                                    <MenuItem value={'PI'} style={{ fontSize: 15 }}>PI</MenuItem>
                                    <MenuItem value={'CRC'} style={{ fontSize: 15 }}>CRC</MenuItem>
                                    <MenuItem value={'Site Manager'} style={{ fontSize: 15 }}>Site Manager</MenuItem>
                                    {adminExist && (
  <MenuItem value={'Study Manager'} style={{ fontSize: 15 }}>
    Study Manager
  </MenuItem>
)}
                                    {/* <MenuItem value={'Study Manager'} style={{ fontSize: 15 }}>Study Manager</MenuItem> */}
                                    <MenuItem value={'Sub-Eye'} style={{ fontSize: 15 }}>Sub-Eye</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        {
                            showFileUpload === 'PI' || showFileUpload === 'CRC'
                                ?
                                <>
                                    <div className='col-md-3 mt-4'>
                                        <label htmlFor="cv">
                                            {/* <AntButton icon={<UploadOutlined />}>Upload CV</AntButton> */}
                                            Upload CV
                                        </label>
                                        <input
                                            name='cv'
                                            type='file'
                                            onChange={e => setCvFile(e.target.files[0])}
                                        ></input>
                                    </div>
                                    <div className='col-md-3 mt-4'>
                                        <label htmlFor="ml">
                                            {/* <AntButton icon={<UploadOutlined />}>Upload ML</AntButton> */}
                                            Upload ML
                                        </label>
                                        <input
                                            name='ml'
                                            type='file'
                                            onChange={e => setMlFile(e.target.files[0])}
                                        ></input>
                                    </div>
                                    <div className='col-md-3 mt-4'>
                                        <label htmlFor="gc">
                                            {/* <AntButton icon={<UploadOutlined />}>Upload GC</AntButton> */}
                                            Upload GC
                                        </label>
                                        <input
                                            name='gc'
                                            type='file'
                                            onChange={e => setGcFile(e.target.files[0])}
                                        ></input>
                                    </div>
                                </>
                                : ''
                        }
                    </div>
                    <div className='col-md-2 mt-4 saveBtnStyle'>
                        <button className="cta" onClick={handleDataSubmit}>
                            <span>Save</span>
                            <svg width="15px" height="10px" viewBox="0 0 13 10">
                                <path d="M1,5 L11,5"></path>
                                <polyline points="8 1 12 5 8 9"></polyline>
                            </svg>
                        </button>
                    </div>
                </Box>
            </Modal >
            <div className='mt-4'>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 700 }} aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell  align="right" >Name</StyledTableCell>
                                <StyledTableCell align="right">Designation</StyledTableCell>
                                <StyledTableCell align="right">Speciality</StyledTableCell>
                                <StyledTableCell align="right">Email</StyledTableCell>
                                <StyledTableCell align="right">Phone</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {allStaffs.length !== 0 ? allStaffs.map((v) => {
                                return (
                                    <StyledTableRow key={v._id}>
                                        <StyledTableCell component="th" scope="row">
                                            <Link style={{ textDecoration: "none" ,fontWeight:'600',fontSize:17, color: '#178383'}} to={`/staffProfile?staffId=${v._id}`}>
                                                {v.name}
                                            </Link>
                                        </StyledTableCell>
                                        <StyledTableCell align="right">{v.designation}</StyledTableCell>
                                        <StyledTableCell align="right">{v.speciality}</StyledTableCell>
                                        <StyledTableCell align="right">{v.email}</StyledTableCell>
                                        <StyledTableCell align="right">{v.phone}</StyledTableCell>
                                    </StyledTableRow>
                                )
                            }) :
                                <StyledTableRow>
                                    <StyledTableCell component="th" scope="row">
                                        No Record Found
                                    </StyledTableCell>
                                </StyledTableRow>
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </Box >
    );
};

export default OrganizationStaff;
